var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "be-live-list" }, [
    _c("div", { staticClass: "be-live-list-header" }, [
      _c("div", { staticClass: "be-live-list-title" }, [
        _vm._v("\n      正在直播\n      "),
        _c("div", { staticClass: "be-live-list-count" }, [
          _vm._v("(" + _vm._s(_setup.items.length) + ")"),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "be-live-list-actions" }, [
        _setup.loaded
          ? _c(
              "div",
              {
                staticClass: "be-live-list-refresh",
                attrs: { title: "刷新" },
                on: { click: _setup.fetchLiveList },
              },
              [_c(_setup.VIcon, { attrs: { icon: "mdi-refresh", size: 16 } })],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "be-live-list-more",
            attrs: {
              target: "_blank",
              href: "https://link.bilibili.com/p/center/index#/user-center/follow/1",
            },
          },
          [
            _vm._v("\n        更多\n        "),
            _c(_setup.VIcon, { attrs: { icon: "right-arrow", size: 14 } }),
          ],
          1
        ),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "be-live-list-search" },
      [
        _c(_setup.VIcon, { attrs: { icon: "search", size: 18 } }),
        _vm._v(" "),
        _c(_setup.TextBox, {
          attrs: { placeholder: "搜索" },
          model: {
            value: _setup.keyword,
            callback: function ($$v) {
              _setup.keyword = $$v
            },
            expression: "keyword",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "be-live-list-content" },
      [
        !_setup.loaded ? _c(_setup.VLoading) : _vm._e(),
        _vm._v(" "),
        _setup.loaded && _setup.filteredItems.length === 0
          ? _c(_setup.VEmpty)
          : _vm._e(),
        _vm._v(" "),
        _vm._l(_setup.filteredItems, function (item) {
          return _c(
            "a",
            {
              key: item.roomid,
              staticClass: "be-live-list-item",
              attrs: { target: "_blank", href: item.link },
            },
            [
              _c(
                "div",
                { staticClass: "be-live-list-item-avatar" },
                [
                  _c(_setup.DpiImage, {
                    attrs: { src: item.face, alt: item.title, size: 36 },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "be-live-list-item-info" }, [
                _c(
                  "div",
                  {
                    staticClass: "be-live-list-item-title",
                    attrs: { title: item.title },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_setup.decodeTitle(item.title)) +
                        "\n        "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "be-live-list-item-user",
                    attrs: { title: item.uname },
                  },
                  [_vm._v("\n          " + _vm._s(item.uname) + "\n        ")]
                ),
              ]),
            ]
          )
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }